import { render, staticRenderFns } from "./Homework.vue?vue&type=template&id=337fa446&scoped=true&lang=pug&"
import script from "./Homework.vue?vue&type=script&lang=ts&"
export * from "./Homework.vue?vue&type=script&lang=ts&"
import style0 from "./Homework.vue?vue&type=style&index=0&id=337fa446&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337fa446",
  null
  
)

export default component.exports